<script>
    import smartToggle from "../../mixins/smartToggle";

    export default {
        name: 'SmartToggle',
        mixins: [smartToggle],
    }
</script>
